import * as React from 'react'
import BoxMui from'@mui/material/Box'

import{IBox,IBoxProps}from'.'

const Box:IBox=React.forwardRef((props:IBoxProps,ref)=><BoxMui {...props} ref={ref}/>)

export default Box
